import { useQuery } from "@tanstack/react-query";
import { globalSearchService } from "@/services/global-search.service";

export function useGlobalSearch(term: string, enabled = true) {
  return useQuery({
    queryKey: ["global-search", term],
    queryFn: () => globalSearchService.search(term),
    enabled: enabled && term.trim().length >= 2,
    staleTime: 30_000,
  });
}
